import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import { businessActions } from 'app-components/flux/business';
import type { Business } from 'app-components/flux/business/businessTypes';
import type { SubmitHandler } from 'app-components/utils/createForm/formBuilder';
import {
  BusinessContactSection,
  BusinessDetailsSection,
  FormProvider,
  businessFormHooks,
} from 'components/BusinessFields';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import { getDrawerSx } from 'components/Drawers/drawerStyles';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import StdDialogTitle from '../StdDialogTitle';

type Props = {
  initialBusiness: any;
  onClose: (e: any) => void;
};

function BusinessEditInner({ onClose }: { onClose: (e: any) => void }) {
  const manager = businessFormHooks.useManager();
  const valid = businessFormHooks.useIsFormValid();

  return (
    <Drawer
      anchor='right'
      open={Boolean(open)}
      onClose={onClose}
      PaperProps={{
        sx: { width: 620 },
      }}
      sx={getDrawerSx()}
    >
      <StdDialogTitle onClose={onClose} showCloseButton={true} showBackButton={false}>
        Edit business
      </StdDialogTitle>

      <StdDialogContent id='business_edit_dialog'>
        <BusinessDetailsSection />
        <Divider sx={{ my: 2 }} />
        <BusinessContactSection />
      </StdDialogContent>

      <StdDialogActions
        primary={{
          id: 'save-business-btn',
          variant: 'contained',
          children: 'Save',
          onClick: () => manager.submit(),
          showTooltip: !valid,
        }}
        secondary={{
          id: 'cancel-edit',
          variant: 'text',
          children: 'Cancel',
          onClick: onClose,
        }}
      />
    </Drawer>
  );
}

export default function BusinessEditDialog(props: Props) {
  const { initialBusiness, onClose } = props;
  const dispatch = useDispatch();

  const handleSubmit: SubmitHandler<Business> = useCallback(
    ({ payload }) => {
      dispatch(businessActions.updateBusiness(payload));
      onClose(undefined);
    },
    [dispatch, onClose],
  );

  return (
    <FormProvider input={initialBusiness} onSubmit={handleSubmit}>
      <BusinessEditInner onClose={onClose} />
    </FormProvider>
  );
}
